import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import NamesGroupContent from './NamesGroupContent';

export default function CasinoNames() {
  return (
    <CasinoContainer title={'Name and group'}>
      <NamesGroupContent />
    </CasinoContainer>
  );
}
